import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import ProfileSubpage from 'Views/Page/Content/Templates/Profile/Templates/ProfileSubpage';
import { root } from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/subpageClasses';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';

const useStyles = buildUseStyles('AccountDebitDisclaimerProfileSubpage', (theme) => ({
  root: root(theme),
}));

const AccountDebitDisclaimerProfileSubpage = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const previousPageRelationship = resource.relationship(fr.relationships.previousPage.name);
  const backLabel = previousPageRelationship?.meta('prompt');
  const backLink = previousPageRelationship?.link('related');
  const { loadPageContentLink } = usePageContentContext();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await resource.link('self').Post();
      loadPageContentLink(backLink);
    } catch (e) {
      displayErrorMessage(e, e.errors);
      setIsLoading(false);
    }
  };

  return (
    <ProfileSubpage
      className={classNames(classes.root, className)}
      title={resource.attr('title')}
      description={resource.attr('subTitle')}
      backLabel={backLabel}
      backLink={backLink}
    >
      <RoundedButton
        variant={'contained'}
        color={'primary'}
        onClick={handleClick}
        isLoading={isLoading}
      >
        {resource.attr('primaryLabel')}
      </RoundedButton>
    </ProfileSubpage>
  );
};

AccountDebitDisclaimerProfileSubpage.defaultProps = {
  className: '',
};

AccountDebitDisclaimerProfileSubpage.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AccountDebitDisclaimerProfileSubpage;
